import { NgModule } from '@angular/core';import { LandingLoginComponent } from './landing-login-component';
import { LandingLoginRoutingModule } from './landing-login-routing.module';
import { LandingLoginService } from './landing-login.service';

import { CommonModule } from '@angular/common';
import { LoginComponent } from '../shared/components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../shared/modules/shared.module';


@NgModule({
    imports: [
        LandingLoginRoutingModule,
    CommonModule,
    SharedModule
        //KvkkPopupModule
    ],
    declarations: [
        LandingLoginComponent,
        LoginComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [LandingLoginService]
})
export class LandingLoginModule { }
